// DRV-5a (#2883) — allowlist for external Google Drive links.
//
// UNUSED in DRV-5a: no web surface renders a Drive URL yet. It is here, with
// its tests, for DRV-5b (folder links, the artefact filing badge), so every
// Drive link that reaches an href goes through one check.
//
// Rules (#2883 adversarial focus): https only, host exactly drive.google.com
// or docs.google.com, no userinfo, default port. Anything else — '' (Drive
// omits webViewLink, see the DRV-2 note on #2883), javascript:/data:/http:,
// look-alike hosts — returns null, and the caller renders no link.

const ALLOWED_HOSTS = new Set(['drive.google.com', 'docs.google.com']);

export function safeDriveUrl(raw: string | null | undefined): string | null {
  if (typeof raw !== 'string') return null;
  let url: URL;
  try {
    url = new URL(raw); // no base: '', relative and protocol-relative inputs throw
  } catch {
    return null;
  }
  if (url.protocol !== 'https:') return null;
  if (!ALLOWED_HOSTS.has(url.hostname)) return null;
  if (url.username !== '' || url.password !== '') return null;
  if (url.port !== '') return null;
  return url.href;
}
